<template>
  <div class="system-summary">
    <el-row type="flex" :gutter="0" style="height:50%">
      <el-col class="card-container bottom-border" style="border-bottom: 2px solid #ECECEC;" :span="14">
        <div class="access-info-card-title">接入情况</div>
        <div class="access-info-card">
          <el-row  type="flex" :gutter="0" style="height:50%">
            <el-col class="number-box-container" :span="6">
              <div class="number-box">
                <div>
                  <div class="box-value">{{stationRegionCount}}</div>
                  <div class="box-label">站所数</div>
                </div>
                <div class="box-right-vertical-line"></div>
              </div>
            </el-col>
            <el-col class="number-box-container" :span="6">
              <div class="number-box">
                <div>
                  <div class="box-value">{{streamNodeCount}}</div>
                  <div class="box-label">视频监控</div>
                </div>
                <div class="box-right-vertical-line"></div>
              </div>
            </el-col>
            <el-col class="number-box-container" :span="6">
              <div class="number-box">
                <div>
                  <div class="box-value">{{enviromentNodeCount}}</div>
                  <div class="box-label">环境监控</div>
                </div>
                <div class="box-right-vertical-line"></div>
              </div>
            </el-col>
            <el-col class="number-box-container" :span="6">
            <div class="number-box">
              <div>
                <div class="box-value">{{powerNodeCount}}</div>
                <div class="box-label">动力监控</div>
              </div>
              <div class="box-right-vertical-line"></div>
            </div>
          </el-col>
          </el-row>
          <el-row  type="flex" :gutter="0" style="height:50%">
            <el-col class="number-box-container" :span="6">
              <div class="number-box">
                <div>
                  <div class="box-value">{{deviceNodeCount}}</div>
                  <div class="box-label">设备监测</div>
                </div>
                <div class="box-right-vertical-line"></div>
              </div>
            </el-col>
            <el-col class="number-box-container" :span="6">
              <div class="number-box">
                <div>
                  <div class="box-value">{{securityNodeCount}}</div>
                  <div class="box-label">安全防范</div>
                </div>
                <div class="box-right-vertical-line"></div>
              </div>
            </el-col>
            <el-col class="number-box-container" :span="6">
              <div class="number-box">
                <div>
                  <div class="box-value">{{fireNodeCount}}</div>
                  <div class="box-label">火灾报警</div>
                </div>
                <div class="box-right-vertical-line"></div>
              </div>
            </el-col>
            <el-col class="number-box-container" :span="6">
              <div class="number-box">
                <div>
                  <div class="box-value">{{controlNodeCount}}</div>
                  <div class="box-label">辅助控制</div>
                </div>
                <div class="box-right-vertical-line"></div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col  class="card-container bottom-border" style="border-bottom: 2px solid #ECECEC;" :span="10">
        <div class="run-info-card-title">运行情况</div>
        <div class="run-info-card">
            <el-row  type="flex" :gutter="0" style="height:50%">
              <el-col class="number-box-container" :span="4">
                <div class="image-box">
                  <div>
                    <div class="device-statistics-box-value"></div>
                    <div class="box-label">设备统计</div>
                  </div>
                  <div class="box-right-vertical-line"></div>
                </div>
              </el-col>
              <el-col class="number-box-container" :span="5">
                <div class="number-box">
                  <div>
                    <div class="box-value">{{encoderCount}}</div>
                    <div class="box-label">接入设备数</div>
                  </div>
                  <div class="box-right-vertical-line"></div>
                </div>
              </el-col>
              <el-col class="number-box-container" :span="5">
                <div class="number-box">
                  <div>
                    <div class="box-value">{{encoderCount - encoderOfflineCount}}</div>
                    <div class="box-label">在线设备数</div>
                  </div>
                </div>
              </el-col>
              <el-col class="number-box-container" :span="5">
                <div class="number-box">
                  <div>
                    <div class="box-value">{{encoderOfflineCount}}</div>
                    <div class="box-label">离线设备数</div>
                  </div>
                </div>
              </el-col>
              <el-col class="number-box-container" :span="5">
              </el-col>
            </el-row>
            <el-row  type="flex" :gutter="0" style="height:50%">
              <el-col class="number-box-container" :span="4">
                <div class="image-box">
                  <div>
                    <div class="alarm-statistics-box-value"></div>
                    <div class="box-label">告警统计</div>
                  </div>
                  <div class="box-right-vertical-line"></div>
                </div>
              </el-col>
              <el-col class="number-box-container" :span="5">
                <div class="number-box">
                  <div>
                    <div class="box-value">{{todayAlarmTimes}}</div>
                    <div class="box-label">今日告警数</div>
                  </div>
                </div>
              </el-col>
              <el-col class="number-box-container" :span="5">
                <div class="number-box">
                  <div>
                    <div class="box-value">{{yesterdayAlarmTimes}}</div>
                    <div class="box-label">昨日告警数</div>
                  </div>
                </div>
              </el-col>
              <el-col class="number-box-container" :span="5">
              <div class="number-box">
                <div>
                  <div class="box-value">{{thisMonthAlarmTimes}}</div>
                  <div class="box-label">当月告警数</div>
                </div>
              </div>
              </el-col>
              <el-col class="number-box-container" :span="5">
                <div class="number-box">
                  <div>
                    <div class="box-value" :class="alarmTimesMonthOnMonth > 0 ? 'positive':'negative'">{{strAlarmTimesMonthOnMonth}}</div>
                    <div class="box-label">月环比</div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
      </el-col>
    </el-row>
    <el-row type="flex" :gutter="0" style="height:50%">
      <el-col :span="14" class="card-container">
        <el-row type="flex" :gutter="0" style="height:100%">
          <el-col :span="12" class="card-container">
            <div class="alarm-trend-card-title">一周告警及设备故障趋势</div>
            <LineChart
              ref="dataLineChart"
              :id="dataLineChartId"
              :source="dataLineChartData"
              :color="dataLineChartColor"
              style="width:100%; height:calc(100% - 41px); min-height: 300px"
            ></LineChart>
          </el-col>
          <el-col :span="12" class="card-container">
            <div class="alarm-type-statistics-card-title">当天告警分类统计</div>
            <annular-pie
              ref="annularPie"
              :id="pieId"
              :source="pieData"
              :color="pieColor"
              :title="pieTitle"
              :legend="pieLegend"
              style="width:100%; height:calc(100% - 41px)"
            ></annular-pie>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="10" class="card-container">
        <div class="recent-alarm-statistics-card-title">最近告警事件一览</div>
        <div class="pagination-table-container">
          <el-table :data="tableData"
                    ref="eventTable"
                    border highlight-current-row
                    element-loading-background="rgba(255, 255, 255, 0.8)"
                    element-loading-spinner="el-icon-loading"
                    element-loading-text="努力加载中..."
                    style="width: 100%">
            <el-table-column label="序号" type="index" width="60"></el-table-column>
            <el-table-column label="区域" prop="regionId" :show-overflow-tooltip="true">
              <template slot-scope="scope">{{ getNameById(scope.row.regionId, $globalData.regions) }}</template>
            </el-table-column>
            <el-table-column label="名称" prop="resourceName" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column label="告警状态" prop="alarmState" width="90">
              <template slot-scope="scope">
                <el-tag :type="scope.row.alarmState === 1 ? 'danger'
                  : scope.row.alarmState === 2 ? 'warning'
                  :'primary'">
                  {{scope.row.alarmStateText}}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="数值" prop="workStateText" width="80"></el-table-column>
            <el-table-column label="事件" prop="eventTypeText" width="120">
              <template slot-scope="scope"> {{scope.row.eventSubType !== 0 ? scope.row.eventSubTypeText : scope.row.eventTypeText}}</template>
            </el-table-column>
            <el-table-column label="发生时间" prop="happenTime" width="160">
              <template slot-scope="scope"> {{strDateTimeFromSTime_t(scope.row.happenTime)}}</template>
            </el-table-column>
          </el-table>
          <el-pagination
            small
            @current-change="handleCurrentPageChange"
            :current-page.sync="tableQueryParams.pageNum"
            :page-size.sync="tableQueryParams.pageSize"
            layout="total, prev, pager, next"
            :total="tableTotalRow">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script type="text/ecmascript-6">
import SystemSummary from './SystemSummary.js'

export default SystemSummary
</script>

<style lang="scss">
  @import "SystemSummary";
</style>



// WEBPACK FOOTER //
// src/views/home/systemSummary/SystemSummary.vue